import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { identifyUser, resetAnalytics, trackPageview } from '../../analytics/tracker'

/**
 * Renders nothing. Keeps PostHog in sync with the session (identify on login and on
 * page reload with a stored session, reset on logout) and sends a pageview on every
 * client-side route change.
 */
function AnalyticsTracker() {
  const { user } = useAuth()
  const location = useLocation()

  const userId = user?.profile?.id || user?.data?.sub || null
  const username = user?.profile?.username || user?.data?.username || null
  const email = user?.profile?.email || null
  const role = user?.profile?.role || user?.data?.role || null

  // Identify before the pageview below so that page is already attributed to the person.
  useEffect(() => {
    if (userId) {
      identifyUser({ id: userId, username, email, role })
    } else {
      resetAnalytics()
    }
  }, [userId, username, email, role])

  useEffect(() => {
    trackPageview({ path: location.pathname })
  }, [location.pathname])

  return null
}

export default AnalyticsTracker
